import { DocumentableType, DocumentDisplayType } from "common/records/Document";
import { IQueryParamsBaseRecord, defaultQueryParamsBase } from "common/records/index/QueryParamsBase";
import { Nullable } from "common/types";
import { Record } from "immutable";

export const documentParamsFromJSON = (data: IDocumentParamsData) => {
  const record = { ...(data as any) };

  return new DocumentParamsRecord(record);
};

export interface IDocumentParamsData extends Partial<IQueryParamsBaseRecord> {
  documentableType: DocumentableType;
  documentableId?: number;
  folder_id?: Nullable<number>;
  signed_kind?: string;
  signed?: "signed" | "unsigned";
  display?: DocumentDisplayType;
  content_type?: string;
}

export interface IDocumentParamsRecord extends IQueryParamsBaseRecord {
  documentableType: DocumentableType;
  documentableId: number;
  folder_id: Nullable<number>;
  signed_kind: Nullable<string>;
  signed: Nullable<string>;
  display: Nullable<DocumentDisplayType>;
  content_type: Nullable<string>;
}

const defaultDocumentParams: IDocumentParamsRecord = {
  ...defaultQueryParamsBase,
  documentableType: "Org",
  documentableId: 0,
  folder_id: null,
  signed_kind: null,
  signed: null,
  display: null,
  content_type: null,
};

export class DocumentParamsRecord extends Record(defaultDocumentParams) implements IDocumentParamsRecord {}
